import { render, staticRenderFns } from "./schedulingEdit.vue?vue&type=template&id=c36bf350&scoped=true"
import script from "./schedulingEdit.vue?vue&type=script&lang=js"
export * from "./schedulingEdit.vue?vue&type=script&lang=js"
import style0 from "./schedulingEdit.vue?vue&type=style&index=0&id=c36bf350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.27_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_bsee5fwwgi4baxsb37pouy7wkq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36bf350",
  null
  
)

export default component.exports